import { Check } from "lucide-react";

const ServiceSection = ({ 
  icon: Icon, 
  title, 
  description, 
  services, 
  image, 
  reverse = false,
  accentColor = "#00E5FF",
  imageContain = false,
  imageBg = null,
  altText = null 
}) => {
  return (
    <div 
      data-testid={`service-section-${title?.toLowerCase().replace(/\s+/g, '-')}`}
      className={`flex flex-col ${reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 items-start py-10`}
    >
      {/* Image */}
      <div className="w-full lg:w-1/2">
        <div className="relative aspect-video rounded-lg overflow-hidden" style={imageBg ? { backgroundColor: imageBg } : undefined}>
          <img
            src={image}
            alt={altText || title}
            className={`w-full h-full ${imageContain ? 'object-contain' : 'object-cover'}`}
            loading="lazy"
            decoding="async"
          />
          <div 
            className="absolute inset-0"
            style={{
              background: `linear-gradient(135deg, ${accentColor}20 0%, transparent 50%)`
            }}
          />
        </div>
      </div>

      {/* Content */}
      <div className="w-full lg:w-1/2">
        <div 
          className="w-14 h-14 rounded-lg flex items-center justify-center mb-6"
          style={{ backgroundColor: `${accentColor}20` }}
        >
          <Icon className="w-7 h-7" style={{ color: accentColor }} />
        </div>
        
        <h3 className="font-display text-3xl md:text-4xl tracking-wide text-white mb-4">
          {title}
        </h3>
        
        <p className="text-[#B3B3B3] text-lg leading-relaxed mb-8">
          {description}
        </p>

        <ul className="space-y-4">
          {services?.map((service, index) => (
            <li key={index} className="flex items-start gap-3">
              <div 
                className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                style={{ backgroundColor: `${accentColor}20` }}
              >
                <Check className="w-4 h-4" style={{ color: accentColor }} />
              </div>
              <span className="text-white">{service}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ServiceSection;
